export default __webpack_public_path__ + "static/media/revLL.3486e94f.png";